/**
 * RequestedChangesTour — 3-step on-ramp for /admin/requested-changes.
 */
import TourOverlay from "@/components/TourOverlay";

const STEPS = [
  {
    id: "deploy",
    selector: '[data-testid="requested-changes-deploy-readiness"]',
    placement: "below",
    title: "Deploy-readiness banner",
    body: "This is your single source of truth. Green = both gates clear (manuals updated AND test admin approved). Red = list of blockers per request.",
    optional: true,
  },
  {
    id: "filters",
    selector: '[data-testid="requested-changes-filters"]',
    placement: "below",
    title: "Filter chips",
    body: "Narrow the list by status. The pipeline runs Pending → Approved to build → Under construction → Built (preview) → Deployed.",
  },
  {
    id: "redeploy",
    selector: '[data-testid="redeploy-btn"]',
    placement: "above",
    title: "Re-deploy app",
    body: "Disabled until both deploy gates clear (manuals + test-admin approval). Click to ship every built_pending_deploy item to production.",
    optional: true,
  },
  {
    id: "done",
    selector: null,
    placement: "center",
    title: "You're set.",
    body: "Use the action buttons inside each row to drive a request through the pipeline. Reset this tour by clearing localStorage.requested_changes_tour_seen_v1.",
  },
];

export default function RequestedChangesTour() {
  return (
    <TourOverlay
      storageKey="requested_changes_tour_seen_v1"
      bannerTitle="First time on Requested Changes?"
      bannerCopy="Take the 30-second tour — deploy-readiness banner, filter chips, re-deploy CTA in 3 quick steps."
      bannerTone="indigo"
      testIdPrefix="requested-changes-tour"
      steps={STEPS}
    />
  );
}
